import { render, staticRenderFns } from "./UserAdminCard.vue?vue&type=template&id=69ecb982&scoped=true"
import script from "./UserAdminCard.vue?vue&type=script&lang=js"
export * from "./UserAdminCard.vue?vue&type=script&lang=js"
import style0 from "./UserAdminCard.vue?vue&type=style&index=0&id=69ecb982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ecb982",
  null
  
)

export default component.exports